export const formatedCategory = (category = '') => {
  if (category === '') {
    return category
  }

  const formatedString = category?.replace(/ /g, '')

  return formatedString?.toLowerCase()
}
